import ajax from '@/api/ajax'
import { SUCC_CODE, AUTH_NAME } from '@/utils/constants'
import storageUtils from '@/utils/storageUtils'

// 获取圈子aliyunoss

const getCircleAliyun = () =>
  ajax(AUTH_NAME.aliyunOss.circleOssInfo, {}, 'POST')

export const circleAliyunOss = {
  data() {
    return {
      circleAliyunOss: {}
    }
  },
  methods: {
    // 获取圈子oss信息
    async setAwsInfo() {
      const respond = await getCircleAliyun()
      const { code, result } = respond
      if (code === SUCC_CODE) {
        this.circleAliyunOss = result.info
        storageUtils.saveCircleAliyunOss(result.info)
      }
    }
  },
  mounted() {
    const info = storageUtils.getCircleAliyunOss()
    if (info && info.image && info.video && info.internal) {
      this.circleAliyunOss = info
    } else {
      this.setAwsInfo()
    }
  }
}
